"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  Browse: "Обзор",
  Change: "Изменить",
  "Drop your image here": "Перетащите изображение сюда",
  "Drop your logo here": "Перетащите логотип сюда",
  Remove: "Удалить",
  "Revert to default": "Восстановить по умолчанию",
  "Sorry, \"{fileName}\" is larger than {maxFileSize} and can't be uploaded. Please upload a file that's {maxFileSize} or smaller.": ['Файл "', ["fileName"], '" не может быть загружен, поскольку его объём превышает ', ["maxFileSize"], ". Загрузите файл размером не более ", ["maxFileSize"], "."],
  "Sorry, \"{fileName}\" is smaller than {minFileSize} and can't be uploaded. Please upload a file that's {minFileSize} or larger.": ['Файл "', ["fileName"], '" не может быть загружен, поскольку его объём менее ', ["minFileSize"], ". Загрузите файл размером не менее ", ["minFileSize"], "."],
  "Sorry, this image format isn't supported. Please provide a {fileTypes}.": ["Этот формат изображений не поддерживается. Поддерживаемые форматы: ", ["fileTypes"], "."],
  "Unsupported file type": "Неподдерживаемый тип файла"
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map